module.exports = __webpack_public_path__ + "img/tn-timeline-misc-17.6c462ab3.jpg";